// src/pages/admin/AddAdminPage.js
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { db } from '../../firebaseConfig'
import {
  doc,
  setDoc,
  serverTimestamp,
  collection,
  getDocs,
} from 'firebase/firestore'

export default function AddAdminPage({ currentAdmin }) {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [role, setRole] = useState('')
  const [roles, setRoles] = useState([])
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  // ============================================================
  // 🔹 Generate UID aman (tanpa Buffer) — menggunakan btoa()
  // ============================================================
  const makeUID = (email) => {
    return btoa(email)
      .replace(/=/g, '')
      .replace(/\+/g, '')
      .replace(/\//g, '')
      .slice(0, 28)
  }

  // ============================================================
  // 🔹 Load role dari Firestore → admin_roles
  // ============================================================
  useEffect(() => {
    const loadRoles = async () => {
      try {
        const snap = await getDocs(collection(db, 'admin_roles'))
        const list = snap.docs.map((d) => d.id)
        setRoles(list)

        // default: role pertama
        if (list.length > 0) setRole(list[0])
      } catch (err) {
        console.error('Error load roles:', err)
      }
    }
    loadRoles()
  }, [])

  // ============================================================
  // 🔹 Simpan admin ke Firestore (isPending = true)
  // ============================================================
  const handleCreate = async (e) => {
    e.preventDefault()
    if (!name || !email || !role) return alert('Lengkapi form.')
    if (!email.includes('@')) return alert('Email tidak valid.')

    setLoading(true)

    try {
      const uid = makeUID(email)

      await setDoc(doc(db, 'admins', uid), {
        name,
        email,
        role,
        isActive: true,
        isPending: true,
        createdAt: serverTimestamp(),
        createdBy: currentAdmin?.uid || 'system',
      })

      alert(
        'Admin berhasil disimpan sebagai pending.\nGunakan tombol "Create Auth" di list admin untuk membuat akun Auth.'
      )

      navigate('/admin-management')
    } catch (err) {
      console.error(err)
      alert('Gagal tambah admin: ' + (err.message || err))
    } finally {
      setLoading(false)
    }
  }

  // ============================================================
  // 🔹 UI
  // ============================================================
  return (
    <div className="p-5 text-white">
      <h1 className="text-2xl font-bold mb-4">Add Admin</h1>

      <form onSubmit={handleCreate} className="space-y-3 max-w-md">
        {/* Name */}
        <div>
          <label className="block text-sm text-gray-300">Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-2 bg-gray-800 rounded border border-gray-700"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm text-gray-300">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 bg-gray-800 rounded border border-gray-700"
          />
        </div>

        {/* Role */}
        <div>
          <label className="block text-sm text-gray-300">Role</label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="w-full p-2 bg-gray-800 rounded border border-gray-700"
          >
            {roles.length === 0 ? (
              <option>Loading...</option>
            ) : (
              roles.map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))
            )}
          </select>
        </div>

        {/* Buttons */}
        <div className="flex gap-2">
          <button
            disabled={loading}
            className="px-4 py-2 bg-blue-600 rounded disabled:opacity-50"
          >
            {loading ? 'Saving...' : 'Save'}
          </button>

          <button
            type="button"
            onClick={() => navigate('/admin-management')}
            className="px-4 py-2 bg-gray-700 rounded"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  )
}
